<template><AntiCheatResults :candidate="candidate" /></template>
<script>
import AntiCheatResults from '@components/AntiCheatResults'
export default { components: { AntiCheatResults }, props: { candidate: { type: Object, default: null } } }
</script>
